import { render } from "./PainelFichas.vue?vue&type=template&id=43380d3a&scoped=true"
import script from "./PainelFichas.vue?vue&type=script&lang=js"
export * from "./PainelFichas.vue?vue&type=script&lang=js"

import "./PainelFichas.vue?vue&type=style&index=0&id=43380d3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43380d3a"]])

export default __exports__